import { EnvironmentModule } from '../manifest/environment-modules';

/**
 * Translated gateway v1 and v2 strings as appropriate
 */
export class GatewayUrls {
    /**
     *Setting connectivity url
     */
    public static settingsConnectivityRelativeUrl = '/settings/connectivity';

    /**
     * Return correct aadUser url depending on the gateway version
     */
    public static get aadUser(): string {
        return EnvironmentModule.isGatewayV200 ? 'aad/user' : 'gateway/aad/user';
    }

    /**
     * Return correct aadApplication url depending on the gateway version
     */
    public static get aadApplication(): string {
        return EnvironmentModule.isGatewayV200 ? 'aad/application' : 'gateway/aad/application';
    }

    /**
     * Return correct aadRegisterStatus url depending on the gateway version
     */
    public static get aadRegisterStatus(): string {
        return EnvironmentModule.isGatewayV200 ? 'aad/registerStatus' : 'gateway/aad/registerStatus';
    }

    /**
     * Return correct aadTokenStatus url depending on the gateway version
     */
    public static get aadTokenStatus(): string {
        return EnvironmentModule.isGatewayV200 ? 'aad/tokenStatus' : 'gateway/aad/tokenStatus';
    }

    /**
     * Return correct aadDeviceCodeUrl url depending on the gateway version
     */
    public static get aadDeviceCodeUrl(): string {
        return EnvironmentModule.isGatewayV200 ? 'aad/CloudName/{0}/deviceCode' : 'gateway/aad/CloudName/{0}/deviceCode';
    }

    /**
     * Return correct aadDeviceCodeWithTenantIdUrl url depending on the gateway version
     */
    public static get aadDeviceCodeWithTenantIdUrl(): string {
        return EnvironmentModule.isGatewayV200 ? 'aad/CloudName/{0}/deviceCode/{1}' : 'gateway/aad/CloudName/{0}/deviceCode/{1}';
    }

    /**
     * Return correct getTenantsUrl url depending on the gateway version
     */
    public static get getTenantsUrl(): string {
        return EnvironmentModule.isGatewayV200 ? 'aad/CloudName/{0}/tenants' : 'gateway/aad/CloudName/{0}/tenants';
    }

    /**
     * Return correct aadSignOut url depending on the gateway version
     */
    public static get aadSignOut(): string {
        return EnvironmentModule.isGatewayV200 ? 'aad/signOut' : 'gateway/aad/signOut';
    }

    /**
     * Return correct aadAppInfo url depending on the gateway version
     */
    public static get aadAppInfo(): string {
        return EnvironmentModule.isGatewayV200 ? 'aad/appInfo' : 'gateway/aad/appInfo';
    }

    /**
     * Return correct disableAadAppAuth url depending on the gateway version
     */
    public static get disableAadAppAuth(): string {
        return EnvironmentModule.isGatewayV200 ? 'aad/disableAadAuth' : 'gateway/aad/disableAadAuth';
    }

    /**
     * Return correct enableAadAuth url depending on the gateway version
     */
    public static get enableAadAuthAuth(): string {
        return EnvironmentModule.isGatewayV200 ? 'aad/enableAadAuth' : 'gateway/aad/enableAadAuth';
    }

    /**
     * Return correct securityGroupActionTemplate url depending on the gateway version
     */
    public static get securityGroupActionTemplate(): string {
        return EnvironmentModule.isGatewayV200 ? 'access/{0}/{1}/type/{2}' : 'gateway/access/{0}/{1}/type/{2}';
    }

    /**
     * Return correct aadAppWithParam url depending on the gateway version
     */
    public static get aadAppWithParam() {
        return EnvironmentModule.isGatewayV200 ? 'aad/cloudName/{0}/application' : 'gateway/aad/cloudName/{0}/application';
    }

    /**
     * Return correct aadAzureAppsWithParam url depending on the gateway version
     */
    public static get aadAzureAppsWithParam() {
        return EnvironmentModule.isGatewayV200 ? 'aad/cloudName/{0}/azureApplications' : 'gateway/aad/cloudName/{0}/azureApplications';
    }

   /**
     * Return correct accessCheck url url depending on the gateway version
     */
    public static get accessCheck(): string {
        return EnvironmentModule.isGatewayV200 ? 'access/check' : 'gateway/access/check';
    }

    /**
     * Return correct accessUser url depending on the gateway version
     */
    public static get accessUsers(): string {
        return EnvironmentModule.isGatewayV200 ? 'access/users' : 'gateway/access/users';
    }

    /**
     * Return correct accessAdmin url depending on the gateway version
     */
    public static get accessAdmins(): string {
        return EnvironmentModule.isGatewayV200 ? 'access/admins' : 'gateway/access/admins';
    }

    /**
     * Return correct adDomainRelativeUrl url depending on the gateway version
     * 'services/WinREST/activeDirectory/domain' is the GWV2 url
     * 'gateway/domain' is the GWV1 url
     */
    public static get adDomainRelativeUrl(): string {
        return EnvironmentModule.isGatewayV200 ? 'services/WinREST/activeDirectory/domain' : 'gateway/domain';
    }

    /**
     * Return correct adAccountsRelativeUrl url depending on the gateway version
     * 'services/WinREST/activeDirectory/accounts' is the GWV2 url
     * 'gateway/accounts' is the GWV1 url
     */
    public static get adAccountsRelativeUrl(): string {
        return EnvironmentModule.isGatewayV200 ? 'services/WinREST/activeDirectory/accounts' : 'gateway/accounts';
    }

    /**
     * Get  latest gateway version url
     */
    public static gatewayVersion = 'gateway/latestVersion';
}
